import { render, staticRenderFns } from "./exchangeDetails.vue?vue&type=template&id=e8d5262a&scoped=true"
import script from "./exchangeDetails.vue?vue&type=script&lang=js"
export * from "./exchangeDetails.vue?vue&type=script&lang=js"
import style0 from "./exchangeDetails.vue?vue&type=style&index=0&id=e8d5262a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8d5262a",
  null
  
)

export default component.exports